import { CustomizableValidator } from '../../../types/Validator';
import { ageChecker, getAge } from './helpers';

interface MinAgeArgs {
  min: number;
}

const errorCode = 'INVALID_MIN_AGE';

const minAge: CustomizableValidator<MinAgeArgs> = ({ min }) => value => {
  const date = String(value);
  if (ageChecker(date, min, Math.min)) {
    const age = getAge(date);
    return {
      errorCode,
      age,
      min,
      value: date
    };
  }
};

export { minAge, errorCode };
